/**
 * 密码规则(逻辑规格 V-1 / 原型 global/login):8 到 20 位,同时含字母和数字,不含空白;
 * 不能与最近 3 次相同(历史由服务端比对)。前后端共用这一份,提示文案也从这里取。
 */
export const PASSWORD_RULE_TEXT = '8 到 20 位,同时含字母和数字';
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 20;
/** 最近几次用过的密码不能再用(含当前这个) */
export const PASSWORD_HISTORY_SIZE = 3;
/** 不合规时返回原因,合规返回 null */
export function passwordProblem(pw) {
    if (pw.length < PASSWORD_MIN || pw.length > PASSWORD_MAX)
        return `密码要 ${PASSWORD_MIN} 到 ${PASSWORD_MAX} 位`;
    if (/\s/.test(pw))
        return '密码不能含空格';
    if (!/[A-Za-z]/.test(pw) || !/\d/.test(pw))
        return '密码要同时含字母和数字';
    return null;
}
//# sourceMappingURL=password.js.map